import React from "react";
import LargeHeaderImage from "./LargeHeaderImage";

export const largeHeaderImageHandler = {
  tags,
  elementEditor,
  defaultStyle,
  component,
  families,
};

function component(element) {
  return <LargeHeaderImage element={element} />;
}

function tags() {
  return {
    startTag: "<!-- Hero Image, Flush : BEGIN -->",
    endTag: "<!-- Hero Image, Flush : END -->",
  };
}

function families() {
  return ["image"];
}

function defaultStyle() {
  return {
    wrapper: {
      backgroundColor: "#ffff",
    },
    elementProps: {
      source: "https://via.placeholder.com/680x300",
      width: "680px",
      height: "300px",
      altText: "alt_text",
      border: "0",
    },
    styleProps: {
      width: "100%",
      maxWidth: "680px",
      height: "300px",
      background: "#dddddd",
      fontFamily: "sans-serif",
      fontSize: "15px",
      lineHeight: "15px",
      color: "#555555",
      margin: "auto",
      display: "block",
    },
    className: "g-img",
  };
}
/* function elementEditor(elementStyle, templateStyle = null, defaultStyle = true) {
    //Take what is relevant from the template
    return (
        `<tr>
            <td style="background-color: #ffffff;">
                <img 
                    src="${elementStyle.elementProps.source}" 
                    width="${elementStyle.elementProps.width}" 
                    height
                    alt="${elementStyle.elementProps.altText}"
                    border="${elementStyle.elementProps.border}"
                    style="width: ${elementStyle.styleProps.width};
                    max-width: ${elementStyle.styleProps.maxWidth}; 
                    height: ${elementStyle.styleProps.height}; 
                    background: ${elementStyle.styleProps.background}; 
                    font-family: ${elementStyle.styleProps.fontFamily}; 
                    font-size: ${elementStyle.styleProps.fontSize}; 
                    line-height: ${elementStyle.styleProps.lineHeight}; 
                    color: ${elementStyle.styleProps.color}; 
                    margin: ${elementStyle.styleProps.margin}; 
                    display: ${elementStyle.styleProps.display};" 
                    class=${elementStyle.className}
                >
            </td>
        </tr>`
    )
}; */

function elementEditor(elementStyle, templateStyle = null, defaultStyle = true) {
  //Take what is relevant from the template
  return `<tr>
        <td style="background-color: transparent;  text-align: center;">
            <img src="${elementStyle.elementProps.source}"  width="680""  alt="alt_text" border="0" style=" 
            width: 100%; max-width: ${elementStyle.elementProps.width}; max-height: ${elementStyle.elementProps.height}; height: auto; background: transparent; font-family: sans-serif; font-size: 15px; line-height: 15px; color: #555555; margin: auto; display: block;" class="g-img">
        </td>
    </tr>`;
}
